'use client';

import Script from 'next/script';
import { useEffect } from 'react';

const GoftinoWidget = () => {
    const widgetId = '2HENTy';
    const scriptUrl = `https://www.goftino.com/widget/${widgetId}`;
    const localStorageKey = `goftino_${widgetId}`;

    useEffect(() => {
        const storedValue = typeof window !== 'undefined' ? localStorage.getItem(localStorageKey) : null;
        const finalUrl = storedValue ? `${scriptUrl}?o=${storedValue}` : scriptUrl;
    }, []);

    return (
        <Script
            src={
                typeof window !== 'undefined' && localStorage.getItem(localStorageKey)
                    ? `${scriptUrl}?o=${localStorage.getItem(localStorageKey)}`
                    : scriptUrl
            }
            strategy="afterInteractive"
            onLoad={() => console.log('Goftino script loaded successfully')}
            onError={(e) => console.error('Error loading Goftino script:', e)}
        />
    );
};

export default GoftinoWidget;